import Nav from "./Nav";
import Footer from "./Footer";

export default function MarketingLayout({ children }) {
  return (
    <div className="bg-ink text-white min-h-screen font-body noise-overlay">
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
